import { PublicIdSchemas } from '@idc-forms/id'
import { z } from 'zod'
import { InstantSchema } from '../primitives/time'

export const V2AdminInventoryCommentAuthorSchema = z
  .object({
    id: PublicIdSchemas.user,
    name: z.string(),
    avatarUrl: z.string().nullable()
  })
  .nullable()

export const V2AdminInventoryCommentReplySchema = z.object({
  id: PublicIdSchemas.inventoryComment,
  body: z.string(),
  author: V2AdminInventoryCommentAuthorSchema,
  parentId: PublicIdSchemas.inventoryComment.nullable(),
  createdAt: InstantSchema
})

export const V2AdminInventoryCommentSchema = V2AdminInventoryCommentReplySchema.extend({
  replies: z.array(V2AdminInventoryCommentReplySchema)
})

export const V2AdminInventoryCommentsSchema = z.object({
  data: z.array(V2AdminInventoryCommentSchema)
})

export const V2CreateAdminInventoryCommentSchema = z.object({
  body: z.string().trim().min(1).max(2000),
  parent: PublicIdSchemas.inventoryComment.optional()
})

export type V2AdminInventoryCommentReply = z.infer<typeof V2AdminInventoryCommentReplySchema>
export type V2AdminInventoryComment = z.infer<typeof V2AdminInventoryCommentSchema>
export type V2AdminInventoryComments = z.infer<typeof V2AdminInventoryCommentsSchema>
export type V2CreateAdminInventoryComment = z.infer<typeof V2CreateAdminInventoryCommentSchema>
